export const SERVICES = [
  {
    id: 1,
    icon: "🧱",
    title: "Albañilería en Motril y Granada",
    description: "Construcción, rehabilitación y reparación de estructuras en Motril, Granada y Costa Tropical. Trabajos de albañilería con materiales de primera calidad.",
    keyword: "albañilería Motril",
  },
  {
    id: 2,
    icon: "🔧",
    title: "Fontanería en Motril",
    description: "Instalación, mantenimiento y reparación de redes de agua, saneamiento y calefacción. Servicio de fontanería urgente en Motril y toda la Costa Tropical.",
    keyword: "fontanería Motril",
  },
  {
    id: 3,
    icon: "🏠",
    title: "Reformas Integrales en Granada",
    description: "Proyectos de reforma completos en Motril, Granada y Costa Tropical: cocinas, baños, interiores y exteriores. Transformamos tu hogar con garantía.",
    keyword: "reformas integrales Granada",
  },
  {
    id: 4,
    icon: "🛡️",
    title: "Reparaciones para Aseguradoras",
    description: "Gestión y ejecución de reparaciones por siniestros en viviendas de Motril y Granada. Colaboramos con las principales aseguradoras para facilitar todo el proceso.",
    keyword: "reparaciones aseguradoras Motril",
  },
  {
    id: 5,
    icon: "🪟",
    title: "Revestimientos y Acabados",
    description: "Alicatados, solados, pintura, yeso y todo tipo de acabados en Motril y Granada. Atención al detalle en cada reforma de vivienda.",
    keyword: "revestimientos Motril",
  },
  {
    id: 6,
    icon: "⚡",
    title: "Reparaciones Urgentes 24h",
    description: "Servicio de reparaciones urgentes en Motril, Granada y Costa Tropical. Respuesta rápida ante roturas, humedades, filtraciones y cualquier emergencia en el hogar.",
    keyword: "reparaciones urgentes Motril",
  },
];

export const WHY_US = [
  {
    icon: "🏆",
    title: "Más de 5 años en la Costa Tropical",
    description: "Trayectoria consolidada en reformas y reparaciones en Motril, Salobreña, Almuñécar y toda la Costa Tropical de Granada.",
  },
  {
    icon: "📋",
    title: "Presupuesto sin compromiso",
    description: "Valoramos tu proyecto de reforma o reparación de forma gratuita y transparente en Motril y Granada, sin letra pequeña ni sorpresas.",
  },
  {
    icon: "🤝",
    title: "Colaboración con aseguradoras",
    description: "Trabajamos directamente con compañías de seguros para facilitar la gestión de siniestros y reparaciones en viviendas de Granada.",
  },
  {
    icon: "⭐",
    title: "Garantía en todos los trabajos",
    description: "Todas nuestras reformas y reparaciones en Motril y Granada incluyen garantía por escrito. Tu tranquilidad es nuestra prioridad.",
  },
];

export const ZONES = [
  { name: "Motril", desc: "Sede principal · zona de referencia" },
  { name: "Torrenueva Costa", desc: "Base de operaciones" },
  { name: "Salobreña", desc: "Reformas y reparaciones" },
  { name: "Almuñécar", desc: "Reformas y reparaciones" },
  { name: "La Herradura", desc: "Reformas y reparaciones" },
  { name: "Vélez de Benaudalla", desc: "Reformas y reparaciones" },
  { name: "Órgiva", desc: "Reformas y reparaciones" },
  { name: "Granada capital", desc: "Proyectos de reforma" },
];

export const FAQS = [
  {
    q: "¿Realizáis reformas en Motril y la Costa Tropical?",
    a: "Sí, somos una empresa de reformas con base en Torrenueva Costa (Motril) y operamos en toda la Costa Tropical de Granada: Motril, Salobreña, Almuñécar, La Herradura, Vélez de Benaudalla y alrededores. Contáctanos para solicitar presupuesto sin compromiso.",
  },
  {
    q: "¿Cuánto cuesta una reforma integral en Granada?",
    a: "El precio de una reforma integral en Granada o Motril depende del estado del inmueble, las calidades elegidas y la superficie a reformar. Ofrecemos presupuesto gratuito y sin compromiso. Llámanos al 623 624 182 o escríbenos a presupuestos@reformasoscaralaminos.es.",
  },
  {
    q: "¿Trabajáis con aseguradoras para reparaciones por siniestros?",
    a: "Sí, colaboramos directamente con las principales compañías de seguros para gestionar y ejecutar reparaciones por siniestros en viviendas de Motril y Granada: humedades, roturas de tuberías, daños estructurales y otros desperfectos. Nos encargamos de toda la documentación.",
  },
  {
    q: "¿Tenéis servicio de reparaciones urgentes en Motril?",
    a: "Sí, disponemos de servicio de atención a urgencias las 24 horas para roturas, filtraciones, inundaciones y cualquier emergencia en el hogar en Motril, Granada y la Costa Tropical. Llámanos al 623 624 182.",
  },
  {
    q: "¿Ofrecéis garantía en los trabajos de reforma?",
    a: "Todos nuestros trabajos de reforma y reparación en Motril y Granada incluyen garantía por escrito. Nuestra prioridad es la satisfacción del cliente y la calidad en cada proyecto.",
  },
  {
    q: "¿Hacéis reformas de baños y cocinas en Motril?",
    a: "Sí, realizamos reformas completas de baños y cocinas en Motril, Granada y toda la Costa Tropical. Desde la demolición hasta los acabados finales: alicatado, fontanería, electricidad, pintura y más.",
  },
];

export const CONTACT = {
  name: "Reparaciones y Reformas Oscar Alaminos",
  address: "Calle Jardines 20, 18720 Torrenueva Costa, Granada",
  phone: "623 624 182",
  web: "reformasoscaralaminos.es",
  tagline: "Calidad y Compromiso en Cada Proyecto",
};
